import React from 'react'

function importSection({color}) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="13.194" height="13.192" viewBox="0 0 13.194 13.192">
        <defs>
        </defs>
        <path className="a" fill={color||"#c4c4c4"} d="M7.628,9.9H5.566a.617.617,0,0,1-.618-.618V4.951H2.688a.514.514,0,0,1-.363-.879L6.244.15a.5.5,0,0,1,.7,0l3.922,3.922a.514.514,0,0,1-.363.879H8.246V9.28A.617.617,0,0,1,7.628,9.9Zm5.566-.206v2.886a.617.617,0,0,1-.618.618H.618A.617.617,0,0,1,0,12.579V9.693a.617.617,0,0,1,.618-.618h3.5V9.28a1.444,1.444,0,0,0,1.443,1.443H7.628A1.444,1.444,0,0,0,9.071,9.28V9.074h3.5A.617.617,0,0,1,13.194,9.693ZM10,11.96a.515.515,0,1,0-.515.515A.517.517,0,0,0,10,11.96Zm1.649,0a.515.515,0,1,0-.515.515A.517.517,0,0,0,11.648,11.96Z" transform="translate(0 -0.005)"/>
        </svg>
    )
}

export default importSection
